<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>
  
  <script>
import * as echarts from 'echarts';
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '420px',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    // lineXData: {
    //   type: Array,
    //   default: [],
    // },
    // lineYData: {
    //   type: Array,
    //   default: [],
    // },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
      sidebarElm: null,
      chartData: {
        visitsData: [],
        ipData: [],
      },
      weekDays: [],
    };
  },
  mounted() {
    this.initChart();

    if (this.autoResize) {
      this.__resizeHandler = this._.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHandler);
    }

    // 监听侧边栏的变化
    this.sidebarElm = document.getElementsByClassName('sidebar-container')[0];
    this.sidebarElm && this.sidebarElm.addEventListener('transitionend', this.sidebarResizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler);
    }

    this.sidebarElm && this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler);

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === 'width') {
        this.__resizeHandler();
      }
    },
    setOptions() {
       let that = this;
      this.chart.setOption(
        {
          legend: {
          bottom:'30px',
          padding:1,
          itemGap:8,
          itemWidth:8,
          itemHeight:8,
          textStyle:{
            color:'#666',
            fontSize:'10px',
            fontFamily:'PingFangSC-Regular, PingFang SC'
          },
          },
          toolbox: {
            show: true,
            feature: {
              // mark: { show: true },
              // dataView: { show: true, readOnly: false },
              // restore: { show: true },
              // saveAsImage: { show: true },
            },
          },
          series: [
            {
              name: 'Nightingale Chart',
              type: 'pie',
              radius: [50, 130],
              center: ['50%', '170px'],
              roseType: 'radius',
              itemStyle: {
                borderRadius: 8,
              },
              data: this.data,
              label: {
                // formatter: '{b}（{c} 人）'
                             formatter: function (params) {
                console.log(params)
                 return that.breakline(params.data.name+'('+ params.data.value+'人)',6) ;
              },
              },
            },
          ],
        },
        true
      );
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions();
    },
        breakline(value,length) {
      var strs = value.split(''); //字符串数组
      var str = '';
      for (var i = 0, s; (s = strs[i++]); ) {
        //遍历字符串数组
        str += s;
        if (!(i %length)) str += '\n'; //按需要求余
      }
      return str;
    },
  },
  watch: {
    data: {
      deep: true,
      handler(newvalue, oldvalue) {
        if (newvalue) {
          this.initChart();
        }
      },
    },
  },
};
</script>
  